import { InitFeatureParams } from '../types'
import { getRoutes } from './routes'

export const initStudents = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
